import React, { useState } from 'react';
import { X } from 'lucide-react';

const EmailDialog = ({ setShowEmailDialog }) => {
  const [isSending, setIsSending] = useState(false);
  const [emailAddress, setEmailAddress] = useState('');
  const [emailSubject, setEmailSubject] = useState('');
  const [emailBody, setEmailBody] = useState('');

  const handleSendEmail = () => {
    setIsSending(true);
    // Add logic to send the email here
    setTimeout(() => {
      setIsSending(false);
      setShowEmailDialog(false);
    }, 2000);
  };

  const handleClose = () => {
    setShowEmailDialog(false);
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  return (
    <div className="fixed inset-0 z-10 overflow-y-auto bg-black bg-opacity-50" onClick={handleBackdropClick}>
      <div className="flex min-h-full items-center justify-center p-4 text-center">
        <div className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all relative" style={{backgroundColor:'#21396c', color:'white'}} onClick={(e) => e.stopPropagation()}>
          {/* Close button */}
          <button
            onClick={handleClose}
            className="absolute top-4 right-4 w-8 h-8 rounded-full bg-white bg-opacity-20 flex items-center justify-center hover:bg-opacity-30 transition-colors"
          >
            <X size={16} className="text-white" />
          </button>

          <h2 className="text-2xl font-bold mb-4">Имэйл илгээх </h2>
          <div className="space-y-4">
            <div>
              <input
                type="email"
                id='email'
                value={emailAddress}
                onChange={(e) => setEmailAddress(e.target.value)}
                placeholder="Имэйл хаягаа оруулна уу"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"required
                style={{color:'black'}}
              />
            </div>
            {/* <div>
              <label htmlFor="subject" className="block text-sm font-medium text-gray-700">
                Subject
              </label>
              <input
                type="text"
                id="subject"
                value={emailSubject}
                onChange={(e) => setEmailSubject(e.target.value)}
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                required
              />
            </div>
            <div>
              <label htmlFor="body" className="block text-sm font-medium text-gray-700">
                Body
              </label>
              <textarea
                id="body"
                rows={5}
                value={emailBody}
                onChange={(e) => setEmailBody(e.target.value)}
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                required
              />
            </div> */}
          </div>
          <div className="mt-4 flex justify-end gap-3">
            <button
              type="button"
              className="inline-flex justify-center rounded-md border border-white border-opacity-30 bg-transparent px-4 py-2 text-sm font-medium text-white hover:bg-white hover:bg-opacity-10 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2"
              onClick={handleClose}
              disabled={isSending}
            >
              Болих
            </button>
            <button
              type="button"
              className="inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
              onClick={handleSendEmail}
              disabled={isSending}
            >
              {isSending ? 'Илгээж байна...' : 'Илгээх'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailDialog;